import(/* webpackMode: "eager" */ "/codebuild/output/src2623389225/src/ui-directo/apps/commerce/src/app/error.tsx");
